import { render, staticRenderFns } from "./textBox.vue?vue&type=template&id=b2886010&scoped=true&"
import script from "./textBox.vue?vue&type=script&lang=js&"
export * from "./textBox.vue?vue&type=script&lang=js&"
import style0 from "./textBox.vue?vue&type=style&index=0&id=b2886010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2886010",
  null
  
)

export default component.exports